import { isEmpty } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { Expensable } from 'modules/expenses/types/Expensable'

export const buildMileageData = (expensable: Expensable) => {
  const from = expensable?.mileage?.from
  const to = expensable?.mileage?.to
  const roundTrip = expensable?.mileage?.roundTrip

  const items = [
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.trip_information_block.from'),
      info: from,
    },
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.trip_information_block.to'),
      info: to,
    },
    {
      //TODO: Adapt based on product decision
      title: i18n.t('expenses_v2.confirmation_screen.expense.trip_information_block.round_trip'),
      info: roundTrip ? i18n.t('common.yes') : i18n.t('common.no'),
    },
  ]

  return items.filter(({ info }) => !isEmpty(info))
}
